import { useState } from 'preact/hooks';
import { hex, shortHex } from '../format';
import { Icon } from './Icon';

/** A hash (or any mono value) in a chip with a one-click copy. */
export function Hash({ value, short = false, copy = true, oneline = false }: { value: Uint8Array | string | undefined; short?: boolean | number; copy?: boolean; oneline?: boolean }) {
  const full = typeof value === 'string' ? value : hex(value);
  const [done, setDone] = useState(false);
  if (!full) return <span class="muted">—</span>;
  const shown = short ? shortHex(full, typeof short === 'number' ? short : 8) : full;
  const doCopy = async () => {
    try {
      await navigator.clipboard.writeText(full);
      setDone(true);
      setTimeout(() => setDone(false), 1200);
    } catch {
      /* clipboard unavailable */
    }
  };
  return (
    <span class={`chip ${oneline ? 'oneline' : ''}`}>
      <code title={full}>{shown}</code>
      {copy && (
        <button type="button" class={`btn-icon ${done ? 'done' : ''}`} onClick={doCopy} title={done ? 'Copied' : 'Copy'} aria-label="Copy">
          <Icon name={done ? 'check' : 'copy'} size={14} />
        </button>
      )}
    </span>
  );
}
